// extracted by mini-css-extract-plugin
export default {"card":"SingleMovie_card__mINmG","img_container":"SingleMovie_img_container__UJhuJ","content":"SingleMovie_content__X11q8"};